import { SVGProps } from 'react'

export enum IconSizes {
    SMALL = '16px',
    MEDIUM = '24px',
    LARGE = '48px',
}

export interface IconProps extends SVGProps<SVGSVGElement> {
    title?: string
    titleId?: string
    size?: IconSizes
}
